import _Popover from "@arco-design/web-react/es/Popover";
import _Table from "@arco-design/web-react/es/Table";
import _Tabs from "@arco-design/web-react/es/Tabs";
import _Spin from "@arco-design/web-react/es/Spin";
import _Result from "@arco-design/web-react/es/Result";
import _Modal from "@arco-design/web-react/es/Modal";
import _Drawer from "@arco-design/web-react/es/Drawer";
import _useRequest from "@byted/hooks/es/useRequest";
import _Typography from "@arco-design/web-react/es/Typography";
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var _a;
import React, { useState } from 'react';
import { getKeyToToken } from '@src/design/redux/reducers/token';
import { GetThemeDiff, SyncThemeFromOrigin } from '@src/utils/api/theme';
import { IconExclamationCircleFill, IconLoading } from '@arco-design/web-react/icon';
import style from './style.less';
var translate = (_a = {}, _a["" + "parent_add"] = {
  text: '父主题新增',
  tip: '父主题新增了对该配置的修改，子主题未修改该配置项'
}, _a["" + "parent_change"] = {
  text: '父主题修改',
  tip: '自上次同步或创建后，父主题修改了该配置项，子主题未修改'
}, _a["" + "both_change"] = {
  text: '同时调整',
  tip: '自上次同步或创建后，父主题修改了该配置项，子主题也修改了该配置项'
}, _a);
var renderValue = function renderValue(val) {
  return /*#__PURE__*/React.createElement(_Typography.Text, {
    style: {
      margin: 0
    },
    ellipsis: {
      cssEllipsis: true,
      showTooltip: true
    }
  }, val);
};
var ThemeDiff = function ThemeDiff(props) {
  var _a = __read(useState([]), 2),
    checkedKeys = _a[0],
    setCheckedKeys = _a[1];
  var _b = _useRequest(function () {
      return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4, GetThemeDiff({
                themeId: props.theme.themeId
              })];
            case 1:
              result = _a.sent();
              return [2, result];
          }
        });
      });
    }, {
      auto: true
    }),
    data = _b.data,
    loading = _b.loading;
  var keyToToken = React.useMemo(function () {
    return getKeyToToken();
  }, []);
  var list = React.useMemo(function () {
    var _a = data || {},
      _b = _a.tokens,
      tokens = _b === void 0 ? [] : _b,
      _c = _a.styles,
      styles = _c === void 0 ? [] : _c;
    var result = {};
    var process = function process(item, type) {
      var _a, _b;
      var isSame = type === 'token' ? item.parent.value === ((_a = item.child) === null || _a === void 0 ? void 0 : _a.value) : item.parent.code === ((_b = item.child) === null || _b === void 0 ? void 0 : _b.code);
      if (!isSame) {
        result[item.parent.component] = result[item.parent.component] || [];
        result[item.parent.component].push(__assign(__assign({}, item), {
          _type: type,
          index: result[item.parent.component].length
        }));
      }
    };
    tokens.forEach(function (item) {
      return process(item, 'token');
    });
    styles.forEach(function (item) {
      return process(item, 'style');
    });
    return result;
  }, [data]);
  React.useEffect(function () {
    var temp = Object.keys(list).reduce(function (total, key) {
      total[key] = list[key].map(function (item) {
        return item.index;
      });
      return total;
    }, {});
    setCheckedKeys(temp);
  }, [list]);
  return /*#__PURE__*/React.createElement(_Drawer, {
    title: "\u540C\u6B65\u7236\u4E3B\u9898",
    width: 860,
    visible: true,
    onCancel: props.onCancel,
    onOk: function onOk() {
      var modal = _Modal.info({
        title: '确定同步父主题吗？',
        content: /*#__PURE__*/React.createElement("div", {
          style: {
            textAlign: 'center'
          }
        }, "\u540C\u6B65\u540E\u6240\u9009\u914D\u7F6E\u9879\u5C06\u4E0E\u7236\u4E3B\u9898\u4FDD\u6301\u4E00\u81F4"),
        onOk: function onOk() {
          return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
              switch (_a.label) {
                case 0:
                  modal.update({
                    title: '正在同步',
                    icon: null,
                    footer: null,
                    content: /*#__PURE__*/React.createElement(_Result, {
                      icon: /*#__PURE__*/React.createElement(IconLoading, null),
                      style: {
                        padding: 0
                      }
                    })
                  });
                  return [4, SyncThemeFromOrigin(__assign({
                    themeId: props.theme.themeId
                  }, Object.keys(list).reduce(function (total, key) {
                    list[key].forEach(function (x) {
                      if (x && checkedKeys[key].indexOf(x.index) > -1) {
                        if (x._type === 'style') {
                          total.styles.push(x);
                        } else {
                          total.tokens.push(x);
                        }
                      }
                    });
                    return total;
                  }, {
                    tokens: [],
                    styles: []
                  })))];
                case 1:
                  _a.sent();
                  _Modal.success({
                    title: '同步成功',
                    icon: null,
                    content: /*#__PURE__*/React.createElement(_Result, {
                      status: "success",
                      title: "\u5237\u65B0\u9875\u9762\u751F\u6548",
                      style: {
                        padding: 0
                      }
                    }),
                    onOk: function onOk() {
                      location.reload();
                    }
                  });
                  return [2];
              }
            });
          });
        }
      });
    },
    okText: "\u540C\u6B65"
  }, loading ? /*#__PURE__*/React.createElement(_Spin, {
    className: "align-loading"
  }) : Object.keys(list).length === 0 ? /*#__PURE__*/React.createElement(_Typography.Text, {
    type: "secondary",
    className: "align-loading"
  }, "\u5F53\u524D\u662F\u6700\u65B0\u7684\uFF0C\u6682\u65E0\u53EF\u540C\u6B65\u7684\u9879") : /*#__PURE__*/React.createElement(_Tabs, {
    type: "text",
    defaultActiveTab: Object.keys(list)[0]
  }, Object.keys(list).map(function (key) {
    return /*#__PURE__*/React.createElement(_Tabs.TabPane, {
      key: key,
      title: key
    }, /*#__PURE__*/React.createElement(_Table, {
      className: style['small-table'],
      size: "small",
      border: false,
      data: list[key],
      rowKey: "index",
      rowSelection: {
        type: 'checkbox',
        selectedRowKeys: checkedKeys[key],
        onSelect: function onSelect(selected, record) {
          var _a;
          setCheckedKeys(__assign(__assign({}, checkedKeys), (_a = {}, _a[key] = Array.from(new Set(selected ? checkedKeys[key].concat(record.index) : checkedKeys[key].filter(function (x) {
            return x !== record.index;
          }))), _a)));
        },
        checkboxProps: function checkboxProps(record) {
          return {
            disabled: record.type === "parent_add"
          };
        }
      },
      columns: [{
        title: '修改项',
        dataIndex: '_type',
        width: 150,
        ellipsis: true,
        render: function render(_type, record) {
          var _a;
          return _type === 'style' ? '自定义样式' : ((_a = record.parent) === null || _a === void 0 ? void 0 : _a.key) || '-';
        }
      }, {
        title: '描述',
        dataIndex: 'index',
        render: function render(_, record) {
          var _a;
          if (record._type === 'style') {
            return '自定义样式';
          }
          var item = keyToToken[(_a = record.parent) === null || _a === void 0 ? void 0 : _a.key];
          return item ? [item.profile.group, item.profile.sort, item.profile.title, item.desc].filter(Boolean).join('/') : '';
        }
      }, {
        title: '父主题',
        dataIndex: 'parent',
        render: function render(x) {
          return renderValue((x === null || x === void 0 ? void 0 : x.value) || (x === null || x === void 0 ? void 0 : x.code) || '-');
        }
      }, {
        title: '当前主题',
        dataIndex: 'child',
        render: function render(x) {
          return renderValue((x === null || x === void 0 ? void 0 : x.value) || (x === null || x === void 0 ? void 0 : x.code) || '-');
        }
      }, {
        title: '类型',
        dataIndex: 'type',
        width: 120,
        render: function render(x) {
          return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(_Popover, {
            content: translate[x].tip
          }, /*#__PURE__*/React.createElement(IconExclamationCircleFill, {
            style: {
              color: 'rgb(var(--warning-6))'
            }
          })), "\xA0", translate[x].text, "\xA0");
        }
      }]
    }));
  })));
};
export default ThemeDiff;